// Autogenerated from `packages/@members/copy/models.generated/__model__.ts.hbs`

export const Aria = {
  Check: 'check',
  Uncheck: 'uncheck',
  FitnessDisciplines: 'fitnessDisciplines',
  BackMonth: 'backMonth',
  ForwardMonth: 'forwardMonth',
  ActiveDay: 'activeDay',
  Warning: 'warning',
  Experiment: 'experiment',
  SkipNavigation: 'skipNavigation',
  PelotonHome: 'pelotonHome',
  MainNavigation: 'mainNavigation',
  FriendsTakenClass: 'friendsTakenClass',
  Class: 'class',
  ClassPreview: 'classPreview',
  ClassPreviewVideo: 'classPreviewVideo',
  ClearSearch: 'clearSearch',
  Close: 'close',
  ReturnToClassPlan: 'returnToClassPlan',
  ChallengesCarousel: 'challengesCarousel',
  SlideCount: 'slideCount',
  CarouselNavigation: 'carouselNavigation',
  CancelLeavingChallenge: 'cancelLeavingChallenge',
  ViewTag: 'viewTag',
  ViewTags: 'viewTags',
  RemoveHighFive: 'removeHighFive',
  GiveHighFive: 'giveHighFive',
  RemoveBookmark: 'removeBookmark',
  AddBookmark: 'addBookmark',
  ViewHighFives: 'viewHighFives',
  DismissCard: 'dismissCard',
  ViewWorkoutDetails: 'viewWorkoutDetails',
  WeeklyStreak: 'weeklyStreak',
  DayWorkedOut: 'dayWorkedOut',
  DayNotWorkedOut: 'dayNotWorkedOut',
  CloseFilters: 'closeFilters',
  CountrySelector: 'countrySelector',
  StateRegionSelector: 'stateRegionSelector',
  WeekNavigation: 'weekNavigation',
  AddToCalendar: 'addToCalendar',
  AddToGoogleCalendar: 'addToGoogleCalendar',
  AddToMicrosoftOutlookCalendar: 'addToMicrosoftOutlookCalendar',
  AddToAppleCalendar: 'addToAppleCalendar',
  AddToCalendarDropdown: 'addToCalendarDropdown',
  ShareClass: 'shareClass',
  DismissPremiereMessage: 'dismissPremiereMessage',
  ShareOnFacebook: 'shareOnFacebook',
  ShareOnStrava: 'shareOnStrava',
  EditInvite: 'editInvite',
  EditClassSchedule: 'editClassSchedule',
  JoinClass: 'joinClass',
  All: 'all',
  Subtitles: 'subtitles',
  CopyLinkToClipboard: 'copyLinkToClipboard',
  StartClass: 'startClass',
  DragToReorder: 'dragToReorder',
  ShareStack: 'shareStack',
  Back: 'back',
  ReplaceTag: 'replaceTag',
  CloseUpgradeModal: 'closeUpgradeModal',
} as const;
